import * as React from 'react'
import { compose, pure } from 'recompose'
import Icon, { IconType } from '../../atoms/Icon/Icon'
import * as styles from './CopyableLabel.css'

interface CopyableLabelProps {
  label: string
}

const copyTextToClipboard = (textVal: string) => {
  const copyFrom = document.createElement('textarea')
  copyFrom.textContent = textVal
  const bodyElm = document.getElementsByTagName('body')[0]
  bodyElm.appendChild(copyFrom)
  copyFrom.select()
  const retVal = document.execCommand('copy')
  bodyElm.removeChild(copyFrom)
  return retVal
}

const CopyableLabel: React.FunctionComponent<CopyableLabelProps> = ({ label }) => {
  return (
    <div className={styles.copyableLabel}>
      <div className={styles.text}>
        <input type="text" value={label} />
      </div>
      <div className={styles.copyButton} onClick={() => copyTextToClipboard(label)}>
        <p className={styles.copyText}>コピー</p>
        <div className={styles.copyIconContainer}>
          <Icon iconType={IconType.COPY_ICON} />
        </div>
      </div>
    </div>
  )
}

export default compose<CopyableLabelProps, CopyableLabelProps>(pure)(CopyableLabel)
